import Toilet from "@/assets/clients/tempula/room/neora/toilet-1.webp"
import Balcony from "@/assets/clients/tempula/room/neora/balcony-1.webp"
import Balcony2 from "@/assets/clients/tempula/room/neora/balcony-2.webp"
import Balcony3 from "@/assets/clients/tempula/room/neora/balcony-3.webp"
import Balcony4 from "@/assets/clients/tempula/room/neora/balcony-4.webp"
import Balcony5 from "@/assets/clients/tempula/room/neora/balcony-5.webp"
import Balcony6 from "@/assets/clients/tempula/room/neora/balcony-6.webp"
import Balcony7 from "@/assets/clients/tempula/room/neora/balcony-7.webp"
import Balcony8 from "@/assets/clients/tempula/room/neora/balcony-8.webp"
import Balcony9 from "@/assets/clients/tempula/room/neora/balcony-9.webp"
import Misc1 from "@/assets/clients/tempula/room/neora/misc-1.webp"
import Misc2 from "@/assets/clients/tempula/room/neora/misc-2.webp"
import Misc3 from "@/assets/clients/tempula/room/neora/misc-3.webp"
import Misc4 from "@/assets/clients/tempula/room/neora/misc-4.webp"
import Misc5 from "@/assets/clients/tempula/room/neora/misc-5.webp"
import Misc6 from "@/assets/clients/tempula/room/neora/misc-6.webp"
import Bedrooom1 from "@/assets/clients/tempula/room/neora/bedroom-1.webp"
import Bedrooom2 from "@/assets/clients/tempula/room/neora/bedroom-2.webp"
import Bedrooom3 from "@/assets/clients/tempula/room/neora/bedroom-3.webp"
import Bedrooom4 from "@/assets/clients/tempula/room/neora/bedroom-4.webp"
import Bedrooom5 from "@/assets/clients/tempula/room/neora/bedroom-5.webp"
import Bedrooom6 from "@/assets/clients/tempula/room/neora/bedroom-6.webp"
import Bedrooom7 from "@/assets/clients/tempula/room/neora/bedroom-7.webp"
import Bedrooom8 from "@/assets/clients/tempula/room/neora/bedroom-8.webp"
import Bedrooom9 from "@/assets/clients/tempula/room/neora/bedroom-9.webp"
import Bedrooom10 from "@/assets/clients/tempula/room/neora/bedroom-10.webp"

const neoraConfig = {
    subInfo: "3 guests · 1 bedroom · 1 bed · 1 private bathroom",
    subInfoClass: "text-xl md:text-2xl text-white font-extralight",

    sections: [
        {
            title: "Bedroom",
            images: [Bedrooom1, Bedrooom2, Bedrooom3, Bedrooom4, Bedrooom5, Bedrooom6, Bedrooom7, Bedrooom8, Bedrooom9, Bedrooom10],
        },
        {
            title: "Bathroom",
            images: [Toilet],
        },
        {
            title: "Balcony",
            images: [Balcony, Balcony2, Balcony3, Balcony4, Balcony5, Balcony6, Balcony7, Balcony8, Balcony9],
        },
        {
            title: "Miscellaneous",
            images: [Misc1, Misc2, Misc3, Misc4, Misc5, Misc6],
        },
    ],

};
export default neoraConfig;
